import { render, staticRenderFns } from "./dialSwiper.vue?vue&type=template&id=ab596e88&scoped=true&"
import script from "./dialSwiper.vue?vue&type=script&lang=js&"
export * from "./dialSwiper.vue?vue&type=script&lang=js&"
import style0 from "./dialSwiper.vue?vue&type=style&index=0&id=ab596e88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab596e88",
  null
  
)

export default component.exports